import { error } from 'pdf-lib';
import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/action-types';

import { EDIT_EVENT_TYPES } from '../../constants/recurrence-constants';

const getCalendarCategorySettingsStart = () => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_START,
  };
};

const getCalendarCategorySettingsSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_SUCCESS,
    calendarCategorySettings: data,
  };
};

const getCalendarCategorySettingsFail = (error) => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORY_SETTINGS_FAIL,
    error: error,
  };
};

export const getCalendarCategorySettings = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getCalendarCategorySettingsStart());
      const url = `/calendar-scheduler/get-category-settings`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getCalendarCategorySettingsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getCalendarCategorySettingsFail(err));
          reject(err);
        });
    });
  };
};

//CalendarCategories
const getCalendarCategoriesStart = () => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORIES_START,
  };
};

const getCalendarCategoriesSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORIES_SUCCESS,
    calendarCategories: data,
  };
};

const getCalendarCategoriesFail = (error) => {
  return {
    type: actionTypes.CALENDAR_GET_CATEGORIES_FAIL,
    error: error,
  };
};

export const getCalendarCategories = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getCalendarCategoriesStart());
      const url = `/calendar-scheduler/get-categories`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getCalendarCategoriesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getCalendarCategoriesFail(err));
          reject(err);
        });
    });
  };
};

//CalendarEvents
const getCalendarEventsStart = () => {
  return {
    type: actionTypes.CALENDAR_GET_EVENTS_START,
  };
};

const getCalendarEventsSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_GET_EVENTS_SUCCESS,
    calendarEvents: data,
  };
};

const getCalendarEventsFail = (error) => {
  return {
    type: actionTypes.CALENDAR_GET_EVENTS_FAIL,
    error: error,
  };
};

export const getCalendarEvents = (pageRequest) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getCalendarEventsStart());
      const url = `/calendar-scheduler/get-events`;

      axios
        .post(url, pageRequest)
        .then((response) => {
          dispatch(getCalendarEventsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getCalendarEventsFail(err));
          reject(err);
        });
    });
  };
};

//CalendarEvents
const saveEventStart = () => {
  return {
    type: actionTypes.CALENDAR_SAVE_EVENT_START,
  };
};

const saveEventSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_SAVE_EVENT_SUCCESS,
    saveEventResult: data,
  };
};

const saveEventFail = (error) => {
  return {
    type: actionTypes.CALENDAR_SAVE_EVENT_FAIL,
    error: error,
  };
};

export const saveEvent = (command) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveEventStart());
      const url = `/calendar-scheduler/save-event`;

      axios
        .post(url, command)
        .then((response) => {
          dispatch(saveEventSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveEventFail(err));
          reject(err);
        });
    });
  };
};

const deleteEventStart = () => {
  return {
    type: actionTypes.CALENDAR_DELETE_EVENT_START,
  };
};

const deleteEventSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_DELETE_EVENT_SUCCESS,
    deleteEventResult: data,
  };
};

const deleteEventFail = (error) => {
  return {
    type: actionTypes.CALENDAR_DELETE_EVENT_FAIL,
    error: error,
  };
};

export const deleteEvent = (command) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteEventStart());
      const url = `/calendar-scheduler/delete-event`;

      axios
        .post(url, command)
        .then((response) => {
          dispatch(deleteEventSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteEventFail(err));
          reject(err);
        });
    });
  };
};

//saveCalendarCategory
const saveCategoryStart = () => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_START,
  };
};

const saveCategorySuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_SUCCESS,
    saveCategoryResult: data,
  };
};

const saveCategoryFail = (error) => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_FAIL,
    error: error,
  };
};

export const saveCategory = (category) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveCategoryStart());
      const url = `/calendar-scheduler/save-category`;

      axios
        .post(url, category)
        .then((response) => {
          dispatch(saveCategorySuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveCategoryFail(err));
          reject(err);
        });
    });
  };
};
//deleteCalendarCategory
const deleteCategoryStart = () => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_START,
  };
};

const deleteCategorySuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_SUCCESS,
    deleteCategoryResult: data,
  };
};

const deleteCategoryFail = (error) => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_FAIL,
    error: error,
  };
};

export const deleteCategory = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteCategoryStart());
      const url = `/calendar-scheduler/delete-category/${id}`;

      axios
        .delete(url)
        .then((response) => {
          dispatch(deleteCategorySuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteCategoryFail(err));
          reject(err);
        });
    });
  };
};

//saveCalendarCategorySetting
const saveCategorySettingStart = () => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_START,
  };
};

const saveCategorySettingSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_SUCCESS,
    saveCategorySettingResult: data,
  };
};

const saveCategorySettingFail = (error) => {
  return {
    type: actionTypes.CALENDAR_SAVE_CATEGORY_SETTING_FAIL,
    error: error,
  };
};

export const saveCategorySetting = (categorySetting) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveCategorySettingStart());
      const url = `/calendar-scheduler/save-category-setting`;

      axios
        .post(url, categorySetting)
        .then((response) => {
          dispatch(saveCategorySettingSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveCategorySettingFail(err));
          reject(err);
        });
    });
  };
};
//deleteCalendarCategorySetting
const deleteCategorySettingStart = () => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_START,
  };
};

const deleteCategorySettingSuccess = (data) => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_SUCCESS,
    deleteCategorySettingResult: data,
  };
};

const deleteCategorySettingFail = (error) => {
  return {
    type: actionTypes.CALENDAR_DELETE_CATEGORY_SETTING_FAIL,
    error: error,
  };
};

export const deleteCategorySetting = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteCategorySettingStart());
      const url = `/calendar-scheduler/delete-category-setting/${id}`;

      axios
        .delete(url)
        .then((response) => {
          dispatch(deleteCategorySettingSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteCategorySettingFail(err));
          reject(err);
        });
    });
  };
};
